import { isArray, isBoolean, isObject, isString } from "lodash";

export type LanTypes = "en" | "uk" | "ka";

export const getLanguageCode = (language: LanTypes) => {
  switch (language) {
    case "en":
      return "en-US";
    case "ka":
      return "ka-GE";
    default:
      return "ua-UA";
  }
};

/**
 * ფუნქცია აბრუნებს ქართულს როცა ქართულია თუარა და ინგლისურს ნებისმიერი ენისთვის
 */
export const getCodeByLanguage = (language: LanTypes) => {
  switch (language) {
    case "ka":
      return "ka";
    default:
      return "en";
  }
};

// https://stackoverflow.com/a/42349521
export const getProp = <T,>(fn: () => T, defaultValue: T): T => {
  try {
    const val = fn();
    if (isBoolean(defaultValue) && !isBoolean(val)) {
      return defaultValue;
    }

    if (isString(defaultValue) && !isString(val)) {
      return defaultValue;
    }

    if (isArray(defaultValue) && !isArray(val)) {
      return defaultValue;
    }

    if (isObject(defaultValue) && !isObject(val)) {
      return defaultValue;
    }

    return val || defaultValue;
  } catch (err) {
    return defaultValue;
  }
};

export const WHITEBIT_VERIFICATION_CHECK_URL =
  "https://whitebit.ge/verification/provider/checking";

export const redirectToWhiteBit = () => {
  window.location.href = WHITEBIT_VERIFICATION_CHECK_URL;
};

export const getMaxDateForBirth = () => {
  const date = new Date();
  return new Date(date.setFullYear(date.getFullYear() - 18));
};
